import { Identity } from '@aclass/admin/base/identity';
import { FormManager } from '@aclass/admin/managers';
import { AppStory, UserStory } from '@aclass/admin/storage/actions';
import { IAdminState, ISystemModuleState, IUserModuleState } from '@aclass/admin/storage/states';
import { ReactiveFormFactory } from '@aclass/core/base/reactive.form.factory';
import { dispatch, NgRedux } from '@angular-redux/store';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';

@Component({
    selector: 'adm-user-profile',
    templateUrl: './profile.component.html'
})
export class UserProfileComponent implements OnInit, OnDestroy {

    ff: ReactiveFormFactory;

    private _saveLoading: boolean;

    private _showProgress: boolean;

    private _shouldLogout: boolean;

    private subscriptions: Array<Subscription> = [];

    get saveLoading(): boolean {
        return this._saveLoading;
    }

    get showProgress() {
        return this._showProgress;
    }

    get shouldLogout(): boolean {
        return this._shouldLogout;
    }

    constructor(
        private ngRdx: NgRedux<IAdminState>,
        private formManager: FormManager
    ) {
    }

    /**
     * @inheritDoc
     */
    ngOnInit() {
        const identity = new Identity(this.ngRdx.getState().systemModule.get('identity'));
        this.ff = new ReactiveFormFactory({
            name: 'User',
            attach: ['userModule', 'profilePageForm'],
            controls: {
                username: new FormControl(identity.username, [Validators.required, Validators.maxLength(255)]),
                email: new FormControl(identity.email, [Validators.required, Validators.email, Validators.maxLength(255)]),
                oldPassword: new FormControl(),
                password: new FormControl(null, [Validators.pattern(/\w{5,}/)]),
                confirmPassword: new FormControl(null, [Validators.pattern(/\w{5,}/)]),
            },
        });
        this._saveLoading = false;
        this._shouldLogout = false;
        this.subscriptions.push(
            this.ngRdx.select<ISystemModuleState['nextPageLock']>(['systemModule', 'nextPageLock'])
                .subscribe(v => this._showProgress = v !== null && v)
        );
        this.subscriptions.push(
            this.ngRdx.select<IUserModuleState['profilePageSaveLock']>(['userModule', 'profilePageSaveLock'])
                .pipe(filter(v => v !== null))
                .subscribe(v => this._saveLoading = v)
        );
        this.subscriptions.push(
            this.ngRdx.select<IUserModuleState['profilePageSaveLock']>(['userModule', 'profilePageShouldLogout'])
                .pipe(filter(v => v !== null))
                .subscribe(v => this._shouldLogout = v)
        );
    }

    /**
     * @inheritDoc
     */
    ngOnDestroy() {
        this.subscriptions.forEach(s => s.unsubscribe());
    }

    @dispatch() logout = () => AppStory.logout();

    @dispatch() save = () => UserStory.submitOnProfilePage();

    runSave() {
        if (!this.ff.validate()) {
            this.ngRdx.dispatch(this.formManager.collectErrors(this.ff));

            return;
        }

        this.save();
    }
}
